export default __webpack_public_path__ + "static/media/PlannedGivingContact.16785744.png";